import type { StorefrontSection } from '@mlm/shared';

type SpacerConfig = Extract<StorefrontSection, { type: 'spacer' }>['config'];

const HEIGHT_CLASS: Record<SpacerConfig['height'], string> = {
  sm: 'h-4',
  md: 'h-8',
  lg: 'h-16',
};

/** Vertical spacer band. */
export function SpacerSection({ section }: { section: StorefrontSection }) {
  const cfg = section.config as SpacerConfig;
  return <div className={HEIGHT_CLASS[cfg.height]} />;
}
